export default __webpack_public_path__ + "static/media/Infographic_mobile.b03ad338.png";